// LOAD ALL THE READ ONLY DATA
import { makeSetReducer } from "./utils";


export const tipoVencimientoFullfilledReducer = makeSetReducer(['tipo_vencimiento/fullfilled']);
